<template>
  <v-dialog
    max-width="600px"
    persistent
    value="true"
  >
    <v-card>
      <v-toolbar
        dense
        flat
        color="primary"
        dark
      >
      Select Reusable Field Type
      </v-toolbar>
      <v-card-text>
        <v-autocomplete
          v-model="selectedReusableFieldType"
          :loading="searching"
          :items="reusablefieldtypes"
          :search-input.sync="search"
          item-value="id"
          item-text="name"
          label="Search Reusable Field Types"
          dense
          auto-select-first
          hide-details
        >
          <template slot="no-data">
            <v-list-tile>
              <v-list-tile-title v-if="!searching && !search">
                Type at least
                <strong>3</strong>
                characters to begin searching
              </v-list-tile-title>
              <v-list-tile-title v-if="!searching && search">
                No results for <i>{{search}}</i>. Refine your search and try again.
              </v-list-tile-title>
              <v-list-tile-title v-if="searching">
                <b><v-icon small>search</v-icon>Searching...</b>
              </v-list-tile-title>
            </v-list-tile>
          </template>
        </v-autocomplete>
        
        <div
          v-if="fieldType"
        >
          <div
            style="padding-top: 10px;"
          >
            <em>{{fieldType.desc || ''}}</em>
          </div>
          <div
            style="border-top: 1px solid rgba(26,26,26,0.3);width:100%;height:1px;margin:10px 0 10px 0;"
          >
          </div>
          <p
            v-if="fieldType.required"
            style="color: red;"
          >
            <b>* Required!</b>
          </p>
          <p
            v-if="fieldType.option_list_object"
          >
            <b>Options: </b> {{printOptionLists(fieldType.option_list_object)}}
          </p>
          <div
            v-if="fieldType.mask_pattern"
          >
            <b>Mask Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{fieldType.mask_pattern}}</span>
          </div>
          <div
            v-if="fieldType.regex_pattern"
          >
            <b>RegEx Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{fieldType.regex_pattern}}</span>
          </div>
          <div
            v-if="fieldType.validation_message"
          >
            <b>Validation Message: </b> {{fieldType.validation_message}}
          </div>
          <div
            v-if="[null, 'custom'].includes(fieldType.atomic_type)"
          >
            <v-card
              v-for="ft in fieldType.subfieldtypes"
              :key="ft.id"
              style="margin-bottom:5px; padding: 5px;"
            >
              <v-chip
                small
                label
                style="text-transform:capitalize;"
              >
                {{ ft.atomic_type_name }}
              </v-chip>
              {{ft.text}} &nbsp;&nbsp;&nbsp;<span v-if="ft.required" style="color:red;">* Required</span>
              <div
                style="padding-left: 15px"
              >
                <div
                  v-if="ft.option_list"
                >
                  <b>Options: </b>
                  <span
                    v-if="showOptList(ft.option_list)"
                  >
                    {{printOptionLists(getOpts[ft.option_list])}}
                  </span>
                  <span
                    v-else
                  >
                    <em>Fetching...</em> {{getPrintOptionLists(ft.option_list)}}
                  </span>
                </div>
                <div
                  v-if="ft.mask_pattern"
                >
                  <b>Mask Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{ft.mask_pattern}}</span>
                </div>
                <div
                  v-if="ft.regex_pattern"
                >
                  <b>RegEx Pattern: </b> <span style="background:rgba(26,26,26,0.05);font-family:monospace;">{{ft.regex_pattern}}</span>
                </div>
                <div
                  v-if="ft.validation_message"
                >
                  <b>Validation Message: </b> {{ft.validation_message}}
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn
					flat
					@click="$emit('cancel')"
				>
					Cancel
				</v-btn>
				<v-btn
					color="info"
          :disabled="!selectedReusableFieldType"
					@click="$emit('save', selectedReusableFieldType)"
				>
					Select
				</v-btn>
			</v-card-actions>
    </v-card>
	</v-dialog>
</template>


<script>
import api from '@/api'

export default {
  name: 'ReusableFieldSelector',
  data () {
    return {
      reusablefieldtypes: [],
      searching: false,
      selectedReusableFieldType: null,
      search: '',
      propDialog: false,
      props: {
        party_name: '',
        form_number: ''
      },
      tagSearch: null,
      tagResults: [],
      copyTags: false,
      fieldType: {},
      getOpts: {}
    }
  },
  watch: {
    search () {
      if (this.search && this.search.length >= 3) {
        this.loadReusableFieldTypes ()
      }
    },
    selectedReusableFieldType () {
      api.formtemplate.fieldType.get(this.selectedReusableFieldType)
        .then(data => {
          this.fieldType = data
        })
    }
  },
  methods: {
    loadReusableFieldTypes () {
      this.searching = true
      api.formtemplate.fieldType.named(this.search).then(data => {
          this.reusablefieldtypes = data['results']
          this.searching = false
        })
    },
    showOptList (option) {
      if (option in this.getOpts)
        return true
      else
        return false
    },
    printOptionLists (opts) {
      var text = ""
      opts.options.forEach((o, i) => {
        text += o.text
        if (i !== opts.options.length - 1)
          text += ", "
      })
      return text
    },
    getPrintOptionLists (opt) {
      api.formtemplate.optionList.get(opt)
        .then(optionList => {
          this.getOpts[opt] = optionList
          this.$forceUpdate()
        })
    },
  }
}
</script>

